import { Observable } from './observable';
export const map = project => source => new Observable(subscriber => {
  source.subscribe(value => subscriber.next(project(value)));
});
export const filter = predicate => source => new Observable(subscriber => {
  source.subscribe(value => {
    if (predicate(value)) {
      subscriber.next(value);
    }
  });
});
export const tap = next => source => new Observable(subscriber => {
  source.subscribe(value => {
    next(value);
    return subscriber.next(value);
  });
});